import { render, staticRenderFns } from "./LogAcessoView.vue?vue&type=template&id=5f419fb4&scoped=true"
import script from "./LogAcessoView.vue?vue&type=script&lang=js"
export * from "./LogAcessoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f419fb4",
  null
  
)

export default component.exports